'use strict';
;(function($, window){

	var timerVar;	
	var isALARendered;
	var HeaderTop = 0;

	$(document)
	.on('shopify:section:load', sectionEdit)
	.on('shopify:section:unload', sectionEdit)
	.on('shopify:section:select', sectionEdit)
	.on('shopify:section:deselect', sectionEdit)
	.on('shopify:block:select', blockEdit)
	.on('shopify:block:deselect', blockEdit);

	$(document).ready(function(){		
		sectionReady();
		navbarClick();
		promobar();
		menu();
		mobileNav();
// 		stuckNav();
		expanderList();
		collapseBlock();
		backToTop();
		videoPlay();
		noellaPlay();
		setReviews();
		ALAcheck();
		productCarousel($('.megaMenuCarousel_js'),true);
		productCarousel($('#mobileGallery'),false);
		if ($(".input-mobile").length && $(".input-desktop").length ) {
			changeInputNameCartPage();
			$(window).resize(changeInputNameCartPage);
		}
		$('body').on('click', '.quick', function(e){
	      	var handle = $(this).attr('data-handle');    
	      	quickView(handle);  
	      	e.preventDefault();
	    });
	    // $('.addtocart').on('click', function(e) {        
	    //   	var productId = $(this).attr('data-id');
	    //   	Shopify.addItemFromFormStart('add-item-form', productId);
	    //   	e.preventDefault();
	    // });
	    if($('.useForm').length){
	    	var el = $('.useForm');
	    	var i;
	    	el.each(function(k,d){
				var subject = $(d).find('a').attr('href').split('#');
	        	$('#selectSubject').append('<option value="'+subject[1]+'">'+subject[1]+'</option>');
	        	if((k+1) == el.length){
	          		$('#selectSubject').parent().show();
	        	}
	    	});
	    	el.on('click', function(e){
	      		e.preventDefault();
	        	var el = $(this),
	            	link = el.find('a').attr('href').split('#');
	        	$('#selectSubject').val(link[1]);
	        	$('#inputName').focus();
	    	});
	  	}
	   
		if($('.template-collection').length){
			//see if an addin banner exists in the collection description
			if($('.title-content img').length){
				//if the banner exists
				var banner = $('.title-content img'),
					bannerSet = [];

				banner.each(function(el){
					var el = $(this),
						bitem,
						copy,
						pack,
						kind;						
						if(el.parent().is('a')){
							bitem = el.parent();
							copy = $('<div />').append($(bitem).clone()).html();
							pack = $('<div class="pitem mobpad col-xs-12 col-sm-4 col-md-4 col-lg-3 col-xl-3">'+copy+'</div>');
							kind = 'addin';
						} else {
							bitem = el;
							copy = $('<div />').append($(bitem).clone()).html();
							pack = $('<div class="mobilemain">'+copy+'</div>');
							kind = 'fallback';
						}					
					bannerSet.push({el:pack,type:kind});
				});				
				var products = $('.product-listing .pitem');

				bannerSet.forEach( function(element, index) {
					// statements
					if(element.type == 'addin'){
						products.eq(2).after(element.el);
					}
					if(element.type == 'fallback'){
						$('.title-box').append(element.el);
					}
				});
				
			}
		}
		$('.search a.search__open').on('click', function(e){
			var drop = $('.search-dropdown');
			if(drop.hasClass('open')){
				drop.hide();
			} else {
				drop.show();
				drop.addClass('open');
			}
			e.preventDefault();
		});
	});

	window.productCarousel = productCarousel;
	window.mobileOnlyCarousel = mobileOnlyCarousel;
	window.listingModeToggle = listingModeToggle;
	window.elevateZoom = elevateZoom;
	window.elevateZoom1 = elevateZoom1;
	window.sliderNoZoom = sliderNoZoom;

	// Sections and Blocks
	function sectionReady(){
		var section = $('.section-box').parent();		
		$.each(section, function(i,el){			
			var target = $(el),
				type = target.find('.section-box').attr('data-section-type');
			switch(type){
				case 'owl-section':					
					slider(target);
					break;
				default:
					// console.log('out');
			}
		});		
	}

	function sectionEdit(event){
		var target = $(event.target),
		type = target.find('.section-box').attr('data-section-type');
		switch(type){
			case 'owl-section':
				slider(target);
				break;
			default:
				// console.log('out');
		}
	}

	function blockEdit(event){
		var target = $(event.target),
		data = target.data(),
		blockType = data[Object.keys(data)[0]].type,
		eventType = event.type || null;
		switch(blockType){
			case 'slider_list':
				goTo(target, eventType);
				break;
			default:
				// console.log('out');
		}
	}

	function slider(target){
		var slider = target.find('.owl-carousel'),
		timer = slider.attr('data-timer');
		slider.owlCarousel({
			loop:true,
			items:1,
			margin:0,
			slideBy:1,
			nav:true,
			autoplay: true,
			autoplayTimeout: timer,
			navText:['',''],
			animateIn: 'fadeIn',
			animateOut: 'fadeOut'
		});
	}
	function goTo(target, eventType){
		var block = $(target),
		pos = block.parent().index(),
		slider = block.parents('.owl-carousel');		
		slider.trigger('to.owl.carousel',[pos,0]);
		slider.trigger('stop.owl.autoplay');
		if(eventType === 'shopify:block:deselect') {
			slider.trigger('play.owl.autoplay');
		}
	}
	// End Sections and Blocks

	// Tools	
	function promobar(){
		$('.promotion_bar .owl-carousel').owlCarousel({
    		loop:true,
    		margin:0,
    		nav:true,    		
    		dots:false,
			slideBy:1,
    		items:1,
    		autoplay:true,
    		autoplayTimeout:4000,
    		autoplayHoverPause:true,
    		navContainer:'#promobar'
  		});
	}
	function menu(){		
		$("nav").each(function(){
			if(!$( this ).hasClass("navbar-vertical")) {
				$( this ).find(".dropdown:not(.no-megamenu-js)").each(function(){
				$( this ).hover(
					function() {
						var $this = $( this );
						var $obj = $this.find(".dropdown-menu");
						if($obj.length) {
							$obj.fadeOut(0);
							timerVar = setTimeout(function(){ 
								$this.addClass("active"); 
								$obj.fadeIn(200);
								submenuXposition($obj);
								submenuYposition($obj);
								$( window ).bind( "scroll", { obj: $obj }, menuScroll);
							}, 300);
						}
					}, function() {
						var $this = $( this );
						var $obj = $this.find(".dropdown-menu");
						clearTimeout(timerVar);
						$( window ).unbind( "scroll", menuScroll);
						if($this.hasClass("active")){
							$obj.fadeOut(300);
							setTimeout(removeActiveItem, 300, $this);
							$( "body" ).hasClass("hidden-menu") && $( "body" ).removeClass("hidden-menu");
						}
					});
				});
			}
		});
		function submenuXposition($obj){
			var w_width = window.innerWidth;
			var o_position = $obj.offset().left;
			var o_width = $obj.outerWidth();
			var delta = parseInt(w_width - o_position - o_width - 25);
			if(delta < 0) {
				$obj.css("left", delta);
			}
		}
		function submenuYposition($obj){
			var w_height = window.innerHeight;
			var o_position = $(".stuck-nav").hasClass("fixedbar") ? $obj.position().top : $obj.offset().top;
			var o_height = $obj.outerHeight();
			var delta = parseInt(w_height - o_position - o_height);
			if(delta < 0) {
				$obj.css({"max-height": o_height + delta - 25, "overflow": "auto"});
				$( "body" ).addClass("hidden-menu");
			}
		}
		function menuScroll(event) {
			event.data.obj.removeAttr("style");
			submenuXposition(event.data.obj);
			submenuYposition(event.data.obj)
		}
		function removeActiveItem(item){
			item.removeClass("active");
			item.removeAttr("style");
			item.find("ul").first().removeAttr("style");
		}
		if($( "nav .dropdown-toggle[href='" + window.location.pathname + "']" ).length) {
			$( "nav .dropdown-toggle[href='" + window.location.pathname + "']" ).parent().addClass("selected");
		}
	}

	function stuckNav(){		
		var navHeight = $('.header-wrapper').outerHeight();
		$('.superspace').css('height',navHeight);		
		$(window).resize(function(){			
			setTimeout(function(){
				var navHeight = $('.header-wrapper').outerHeight();
				console.log(navHeight);
				$('.superspace').css('height',navHeight);
			}, 250);			
		});		
	}

	function navbarClick() {
    	var windowW = window.innerWidth || $(window).width();
		// mobile menu off width
		if (windowW > 1025) {
			$('.navbar .dropdown > a').on('click', function(){
				location.href = this.href;
				return false
			});
		}
		if (windowW > 1025 && $('html').hasClass('touch')) {
			$('.navbar .dropdown > a').on('click', function(e){
				var attr = $(this).attr('aria-expanded');
				if(attr == "true"){
					location.href = this.href;
					return false
				}
			});
		}
	}

	function mobileNav(){
		if ($(".navbar-toggle").length > 0) {
			$('.navbar-toggle').click(function () {
				$(".mobile-menu-wrapper").addClass('open');
				$("body").addClass('no-scroll');        
			});  
			$('#cboxClose').click(function () {
				$('.mobile-menu-wrapper, .mobile-menu-popup').removeClass('open');
				$("body").removeClass('no-scroll')
			});
			$('.mobile-menu-popup').click(function () {
				$('.mobile-menu-wrapper').removeClass('open');
				$("body").removeClass('no-scroll')
			});         
		} 
		$("#off-canvas-menu .expander-list").find("ul").hide().end().find(" .expander").text("+").end().find(".active").each(function() {
			$(this).parents("li ").each(function() {
				var $this = $(this),
				$ul = $this.find("> ul"),
				$expander = $this.find("> .name .expander");
				if($ul.length){
					$ul.show();
					$expander.html("&minus;")	
				}				
			});
		}).end().find(" .expander").each(function() {
			var $this = $(this),
			hide = $this.text() === "+",
			$ul = $this.parent(".name").next("ul"),
			$name = $this.next("a");			
			$this.click(function() {
				if ($ul.css("display") == "block"){
					$ul.slideUp("slow");
				} else {
					$ul.slideDown("slow");
					$(this).html(hide ? "&minus;" : "+");             
					hide = !hide;
				}
			});
		});
		$("#off-canvas-menu .expander-list > li").each(function(){
			var el = $(this);
			if(el.find(' > .multicolumn-level').length){

			} else {
				el.find('.expander').hide();
			}
		});		
	}

	function expanderList() {
		$('.expander-list .expander').each(function() {
			if ($(this).parent('li').hasClass('active')){
				$(this).next('ul').slideDown(0);
				$(this).parent().addClass('open');
			}
		});
		$(".expander-list .expander").on('click', function(e) {
			e.preventDefault();
			var speed = 300;
			var thisItem = $(this).parent(),
			nextLevel = $(this).next('ul');
			if (thisItem.hasClass('open')){
				thisItem.removeClass('open');
				nextLevel.slideUp(speed);
			} else {
				thisItem.addClass('open');
				nextLevel.slideDown(speed);
			}
		});
	}

	function collapseBlock() {
		$('.collapse-block__content').each(function() {
			if ($(this).parent('.collapse-block').hasClass('open')){
				$(this).slideDown(0);
			}
		});
		$('.collapse-block__title').on('click', function(e) {
			e.preventDefault();
			var speed = 300;
			var thisItem = $(this).parent(),
			nextLevel = $(this).next('.collapse-block__content');
			if (thisItem.hasClass('open')){
				thisItem.removeClass('open');
				nextLevel.slideUp(speed);
			} else {
				thisItem.addClass('open');
				nextLevel.slideDown(speed);
			}
		});
	}	

	function listingModeToggle() {    
		$('a.link-row-view').on('click', function(e) {
			e.preventDefault();
			$(this).addClass('active');
			$('a.link-grid-view').removeClass('active');
			$('.product-listing').addClass('row-view');
		});		
		$('a.link-grid-view').on('click', function(e) {
			e.preventDefault();
			$(this).addClass('active');
			$('a.link-row-view').removeClass('active');
			$('.product-listing').removeClass('row-view');
		});
	}

	function backToTop(){
		if ($(".back-to-top").length > 0) {
			$('.back-to-top').on('click', function(e){
				$('html, body').animate({scrollTop: 0},500);
				e.preventDefault();
			});
			$(window).scroll(function () {
				if($(window).scrollTop() > 500){
					$(".back-to-top").addClass('fadein');
				} else {
					$(".back-to-top").removeClass('fadein');
				}
			});
		} 
	}

	function productCarousel(carousel,nav){    
		var showNav = false;
		if(nav){
			showNav = true;
		}
		carousel.each(function(i, el){
			var elem = $(el);      
			elem.owlCarousel({
				loop:true,
				margin:0,
				nav:showNav,
				dots:false,
				mouseDrag:false,
				touchDrag:false,
				pullDrag:false,
				lazyLoad:true,
				lazyLoadEager:2,
				items:1
			});
		});    
	}

	function mobileOnlyCarousel() {
		var windowW = window.innerWidth || $(window).width();
		var carouselMobileOnly = $('.carousel-products-mobile');
		if (windowW < 480) {
			carouselMobileOnly.each(function(){
				if (!$(this).hasClass('slick-initialized')){
					$(this).slick({
						slidesToShow: 1,
						slidesToScroll: 1
					});
				}
			});
		}
		$(window).resize(debouncer(function(e) {    
			var currentW = window.innerWidth || $(window).width();
			var carouselMobileOnly = $('.carousel-products-mobile');
			if (currentW < 480) {
				if(carouselMobileOnly && carouselMobileOnly.length) {
					carouselMobileOnly.slick({
						slidesToShow: 1,
						slidesToScroll: 1
					});
				}
			} else {
				if (carouselMobileOnly.hasClass('slick-initialized')){
					carouselMobileOnly.slick('unslick');
				}
			}
		}));
	}

	function elevateZoom() {
		var windowW = window.innerWidth || document.documentElement.clientWidth;
		$('.product-zoom').imagesLoaded(function() {
			if ($('.product-zoom').length) {
				var zoomPosition
				if ( $('html').css('direction').toLowerCase() == 'rtl' ) {
					zoomPosition = 11;
				} else {
					zoomPosition = 1
				}
				if (windowW > 767) {
					$('.product-zoom').elevateZoom({	
						zoomWindowWidth: $('.product-zoom').width()- 60,
						zoomWindowHeight: $('.product-zoom').width() - 60,
						gallery: "smallGallery",
						galleryActiveClass: 'active',
						zoomWindowPosition : zoomPosition
					});
				} else {
					$(".product-zoom").elevateZoom({
						gallery: "smallGallery",
						zoomType: "inner",
						galleryActiveClass: 'active',
						zoomWindowPosition : zoomPosition
					});
				}
			}
		});
		$('.product-main-image > .product-main-image__zoom ').bind('click', function(){
			galleryObj = [];
			current = 0;
			itemN = 0;    
			if ($('#smallGallery').length){
				$('#smallGallery li a').not('.video-link').each(function() {
					if ($(this).hasClass('active')) {
						current = itemN;
					}
					itemN++;
					var src = $(this).data('zoom-image'),
					type = 'image';
					image = {};
					image ["src"] = src;
					image ["type"] = type;
					galleryObj.push(image);
				});
			} else {
				itemN++;
				var src = $(this).parent().find('.product-zoom').data('zoom-image'),
				type = 'image';
				image = {};
				image ["src"] = src;
				image ["type"] = type;
				galleryObj.push(image);
			}
			$.magnificPopup.open({
				items: galleryObj,
				gallery: {
					enabled: true,
				}
			}, current);   
		});
		var  prevW = windowW;
		$(window).resize(debouncer(function(e) {
			var currentW = window.innerWidth || $(window).width();
			if (currentW != prevW) {
				// start resize events
				$('.zoomContainer').remove();
				$('.elevatezoom').removeData('elevateZoom');
				if ($('.product-zoom').length) {
					if (currentW > 767) {
						$('.product-zoom').elevateZoom({
							zoomWindowHeight: $('.product-zoom').height(),
							gallery: "smallGallery"
						});
					} else {
						$(".product-zoom").elevateZoom({
							gallery: "smallGallery",
							zoomType: "inner"
						});
					}
				}    
				// end resize events  
			}
			prevW = window.innerWidth || $(window).width();
		}));
	}

	function elevateZoom1() {
		var currentW = window.innerWidth || $(window).width();
		if (currentW > 767) {
			if ($('.product-zoom1').length) {
				$('.product-zoom1').elevateZoom({
					zoomType: "inner",
					cursor: "crosshair",
					zoomWindowFadeIn: 300,
					zoomWindowFadeOut: 300
				});
			}
		}
	}

	function sliderNoZoom(){
		if ($(".slider-no-zoom").length > 0) {
			$('.slider-product-large').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
              
				arrows: false,
				fade: true,
				centerPadding: '40px',
				infinite: true,
				asNavFor: '.slider-product-small'
			});
			$('.slider-product-small').slick({
				slidesToShow: 4,
				slidesToScroll: 1,
				infinite: true,
				asNavFor: '.slider-product-large',
				dots: true,
				centerPadding: '40px',
				focusOnSelect: true
			});
		}
	}

	function changeInputNameCartPage() {
		var name= "updates[]";
		if ($(window).width() > 767) {
			$(".input-mobile").attr("name", "");
			$(".input-desktop").attr("name", name);
		} else {
			$(".input-mobile").attr("name", name);
			$(".input-desktop").attr("name", "");
		}
	}

	function debouncer(func, timeout) {
		var timeoutID, timeout = timeout || 500;
		return function() {
			var scope = this,
			args = arguments;
			clearTimeout(timeoutID);
			timeoutID = setTimeout(function() {
				func.apply(scope, Array.prototype.slice.call(args));
			}, timeout);
		}
	}

  	
  	function videoPlay(){
  		$('.videoPlay').on('click', function(e){
  			var playing = $('.videoPlay .img iframe'),
  			el = $(this),
  			newVideo = el.find('.img .hold'),
  			id = el.attr('data-id'),
  			frame = '<iframe width="560" height="315" src="https://www.youtube.com/embed/'+id+'?rel=0&autoplay=1&vq=hd1080" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
  			playing.remove();
  			newVideo.append(frame);
  			e.preventDefault();
  		});
  	}

  	function noellaPlay(){
  		$('.playback').on('click', function(e){
  			var el = $(this),
  			id = el.attr('data-id'),
  			parent = el.parents('.prime-banner'),
  			holder = parent.find('.video-content'),
  			video = '<iframe width="560" height="315" src="https://www.youtube.com/embed/'+id+'?rel=0&autoplay=1&vq=hd1080" frameborder="0" allowfullscreen="1" scrolling="no" allow="autoplay; encrypted-media"></iframe>';
  			if(id){
  				holder.html(video).fadeIn('330');	
  			}  			
  			e.preventDefault();
  		})
  	}

  	function setReviews(){
		if($(window).width() > 767){
			if($('.add_review').length > 0){
				$('.add_review').click(function(e){
					$('#nav-tabs--ys li a').each(function(){
						if($(this).text().trim() == 'REVIEWS'){        
							$(this).trigger('click');
						}
					});
					if($(window).scrollTop() > HeaderTop){
						var headerHeight = $('.stuck-nav').height();
					}else{
						var headerHeight = $('.stuck-nav').height() + $('.custum_header').height();
					}
					$('html, body').animate({
						scrollTop: $(jQuery(this).attr('href')).offset().top - headerHeight
					}, 2000);
					e.preventDefault();
				});
			}
		}
		else{
			if($('.add_review').length > 0){
				$('.add_review').click(function(e){					
					var headerHeight = $('.stuck-nav').height() + 70;        
					$('.desktop-hidden.custm_mob_tab .mob-heading').each(function(){
						if($(this).text().trim() == 'REVIEWS'){ 
							$('html, body').animate({
								scrollTop: $('#shopify-product-reviews').offset().top - headerHeight
							}, 2000);
						}
					});
					e.preventDefault();
				});
			}      
		}
  	}
	
	function ALAcheck() {
		isALARendered = setInterval(function () {
			customALA();
		}, 200);
	}
	function customALA() {
		if(jQuery('.product-info__review .spr-badge-caption').length > 0) {
			clearInterval(isALARendered);    
			jQuery('.product-info__review .spr-badge-caption').click(function(e){				
				jQuery('.add_review').trigger('click');
				e.preventDefault();
			});
			if(window.location.href.indexOf("#shopify-product-reviews") > -1) {
				jQuery('.add_review').trigger('click');          
			}
		}              
	}
	// End Tools

})(jQuery, window);